module.exports = __webpack_public_path__ + "static/media/rotation.65d27360.svg";